import React from "react";

const PLACEHOLDER =
  "data:image/svg+xml," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"><rect fill="#e9ecef" width="100%" height="100%"/></svg>'
  );

const onImgError = (event) => {
  const img = event.currentTarget;
  if (img.dataset.tklFallback === "1") {
    return;
  }
  img.dataset.tklFallback = "1";
  img.removeAttribute("data-src");
  img.removeAttribute("data-srcset");
  img.removeAttribute("srcset");
  img.src = PLACEHOLDER;
};

const generateSrcset = (normal, retina) => {
  let str = "";
  if (normal && retina) {
    str += normal + " 1x, " + retina + " 2x, ";
  }
  if (normal && !retina) {
    str += normal + " 1x";
  }
  if (!normal && retina) {
    str += retina + " 1x";
  }
  return str;
};

const uniqueImageUrls = (imgdata) => {
  return [
    ...new Set(
      Object.values(imgdata).filter(
        (url) =>
          typeof url === "string" &&
          url.length > 0 &&
          !url.includes("undefined")
      )
    ),
  ];
};

const ComponentResponsiveImg = React.memo(function ComponentResponsiveImg(
  props
) {
  const imgdata = (props || {}).imgdata || {};
  const urls = uniqueImageUrls(imgdata);
  const primary = imgdata.xs || imgdata.sm || urls[0] || PLACEHOLDER;

  if (urls.length <= 1) {
    return (
      <img
        className="lazyload"
        src={PLACEHOLDER}
        data-src={primary}
        alt=""
        style={{ height: "100%" }}
        onError={onImgError}
      />
    );
  }

  return (
    <picture>
      {imgdata.xxl || imgdata.xxl2 ? (
        <source
          media="(min-width: 1600px)"
          data-srcset={generateSrcset(imgdata.xxl, imgdata.xxl2)}
        />
      ) : null}
      {imgdata.xl || imgdata.xl2 ? (
        <source
          media="(min-width: 1200px)"
          data-srcset={generateSrcset(imgdata.xl, imgdata.xl2)}
        />
      ) : null}
      {imgdata.lg || imgdata.lg2 ? (
        <source
          media="(min-width: 1024px)"
          data-srcset={generateSrcset(imgdata.lg, imgdata.lg2)}
        />
      ) : null}
      {imgdata.sm || imgdata.sm2 ? (
        <source
          media="(min-width: 768px)"
          data-srcset={generateSrcset(imgdata.sm, imgdata.sm2)}
        />
      ) : null}
      {imgdata.xs || imgdata.xs2 ? (
        <source
          media="(min-width: 300px)"
          data-srcset={generateSrcset(imgdata.xs, imgdata.xs2)}
        />
      ) : null}
      <img
        className="lazyload"
        src={PLACEHOLDER}
        data-src={primary}
        data-srcset={generateSrcset(imgdata.xs, imgdata.xs2)}
        alt=""
        style={{ height: "100%" }}
        onError={onImgError}
      />
    </picture>
  );
});

export default ComponentResponsiveImg;
